// extracted by mini-css-extract-plugin
export default {"indicator":"indicator_indicator__jI3rx","active":"indicator_active__3lF8W","hidden":"indicator_hidden__FqEEE","small":"indicator_small__V7Qnt"};